import script from "./recruiterSignin.vue?vue&type=script&lang=js"
export * from "./recruiterSignin.vue?vue&type=script&lang=js"

import "./recruiterSignin.vue?vue&type=style&index=0&id=ebb2c09a&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebb2c09a"]])

export default __exports__